import _ from "lodash";
// export interface WeekFilter {
//   condition: ParamCondition<AgendaCase[][]>;
//   type: "week";
//   action: ParamAction<AgendaCase[][]>;
//   reason?: string;
// }
//
// export interface DayFilter {
//   condition: (dayArray: AgendaCase[]) => boolean;
//   type: "day";
//   action: (weekArray: AgendaCase[]) => AgendaCase[];
//   reason?: string;
// }
//
// export interface CaseFilter {
//   condition: (caseRdv: AgendaCase) => boolean;
//   type: "case";
//   action: (kase: AgendaCase) => AgendaCase;
//   reason?: string;
// }
//export type FilterInitObj = WeekFilter | DayFilter | CaseFilter;
export default class FilterObject {
    constructor(condition, action, type, reason) {
        this.condition = condition;
        this.type = type;
        this.reason = reason;
        this.messages = [];
        this.action = action;
    }
    process(weekArray) {
        if (this.type === "week") {
            const cond = this.condition;
            const action = this.action;
            if (cond(weekArray)) {
                if (this.reason) {
                    this.messages.push(this.reason);
                }
                return action(weekArray);
            }
            else {
                return weekArray;
            }
        }
        if (this.type === "day") {
            const cond = this.condition;
            const action = this.action;
            return weekArray.map((day) => {
                if (cond(day)) {
                    if (this.reason) {
                        this.messages.push(this.reason);
                    }
                    return action(day);
                }
                else {
                    return day;
                }
            });
        }
        // if (this.type === "case") {
        //   const cond = this.condition as ParamCondition<TwoTargets<"case">>;
        //   const action = this.action;
        //   return weekArray.map((day) =>
        //     day.map((kase) => {
        //       if (cond(kase)) {
        //         if (this.reason) {
        //           this.messages.push(this.reason);
        //         }
        //         return action(kase);
        //       } else {
        //         return kase;
        //       }
        //     })
        //   );
        // }
        throw new Error("should never get here in FilterObject process method");
    }
    getMessages() {
        return _.uniq(_.compact(this.messages)); //compact au cas où on aurait des messages undefined si raison n'a pas été fournie lors de la création du filterObject
    }
}
//# sourceMappingURL=filterObject.js.map